// DTO
import { type IconOneFlagsName } from '@23/web-components/dist/types/components/0_components/icon/icons-list'

type ProfileDTO = {
  company: string
  role: string
  city: string
  regionName: string
  country: string
  countryCode: IconOneFlagsName
  firstname: string
  lastname: string
  avatar: string
}

type AudienceMemberDTO = {
  uuid: string
  identifier: number
  email: string
  attended_type: string
  profile?: ProfileDTO
  recent: string
  timeline_engagement: number
  attended_engagement: number
  attendance_registration_date: string
  timeline_count: number
  timelines?: TimelineDTO[]
}

// ==================

type AudienceMember = {
  uuid: string
  identifier: number
  email: string
  attendedType: string
  profile?: Profile
  recent: string
  timelineEngagement: number
  attendedEngagement: number
  attendanceRegistrationDate: string
  views: number
  timelines?: Timeline[]
}

type Profile = {
  company: string
  role: string
  city: string
  regionName: string
  country: string
  countryCode: IconOneFlagsName
  firstname: string
  lastname: string
  avatar: string
}

type TimelineDTO = {
  object: string
  type: string
  active: boolean
}

type Timeline = {
  object: string
  active: boolean
}

type Event = {
  type: string
  object: string
}

const mapDTOToProfile = (dto?: ProfileDTO): Profile | undefined => {
  if (!dto) return undefined
  return {
    countryCode: dto.countryCode,
    avatar: dto.avatar,
    firstname: dto.firstname,
    lastname: dto.lastname,
    company: dto.company,
    city: dto.city,
    country: dto.country,
    regionName: dto.regionName,
    role: dto.role,
  }
}

const mapDTOToAudienceMember = (dto: AudienceMemberDTO): AudienceMember => {
  return {
    uuid: dto.uuid,
    identifier: dto.identifier,
    email: dto.email,
    attendedType: dto.attended_type,
    profile: mapDTOToProfile(dto.profile),
    recent: dto.recent,
    timelineEngagement: dto.timeline_engagement,
    attendedEngagement: dto.attended_engagement,
    attendanceRegistrationDate: dto.attendance_registration_date,
    views: dto.timeline_count,
    timelines: dto.timelines?.map((timeline) => ({
      object: timeline.object,
      active: timeline.active,
    })),
  }
}

export {
  type AudienceMember,
  type AudienceMemberDTO,
  type Profile,
  type Timeline,
  type Event,
  mapDTOToAudienceMember,
}
